module.exports = __webpack_public_path__ + "static/cpm-video-image-98491ffc7f9eebcd9488813a7a58388b.png";